"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _AuthProvider = _interopRequireDefault(require("../../providers/AuthProvider"));
var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Input = _interopRequireDefault(require("../Input"));
var _Select = _interopRequireDefault(require("../Select"));
var _Button = _interopRequireDefault(require("../Button"));
var _oneClub = require("../../services/oneClub");
var _validation = require("../../utils/validation");
var _index = require("../../constants/index");
var _Login = require("./Login.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 登入組件
 */

const Login = _ref => {
  var _authState$context$re;
  let {
    platformName
  } = _ref;
  const {
    useAuthDispatch,
    useAuthState
  } = _AuthProvider.default;
  const {
    eventType: AuthEventType,
    state: AuthStates
  } = _AuthMachine.default;
  const history = (0, _reactRouterDom.useHistory)();
  const authDispatch = useAuthDispatch();
  const authState = useAuthState();
  const [state, setState] = (0, _react.useState)({
    password: {
      value: "",
      message: ""
    },
    account: {
      value: "",
      message: ""
    },
    edu: "",
    errorMessage: ""
  });
  const onChange = (key, event) => {
    const value = event.target.value;
    setState({
      ...state,
      errorMessage: "",
      [key]: {
        value,
        message: ""
      }
    });
  };
  const submit = async () => {
    // let cantSubmit = false;
    const values = {
      account: state.account.value,
      password: state.account.value
    };
    const rules = {
      account: [{
        message: "帳號欄位不得為空",
        validate: _validation.required
      }],
      password: [{
        message: "密碼欄位不得為空",
        validate: _validation.required
      }]
    };
    const [isPass, errorGroup] = (0, _validation.createValidator)(values, rules);
    setState({
      ...state,
      errorGroup
    });
    if (isPass) return;
    const result = await (0, _oneClub.sendData)(state.account.value, state.password.value);
    if (result.code !== "SUCCESS") {
      setState({
        ...state,
        account: {
          value: "",
          message: ""
        },
        password: {
          value: "",
          message: ""
        },
        errorMessage: "\u767B\u5165\u5931\u6557\uFF1A".concat(result.message)
      });
      return;
    }
    authDispatch(AuthEventType.Logging, {
      jwt: result.jwt
    });
  };
  const confirmHandle = () => {
    authDispatch(AuthEventType.SetEducation, {
      chooseEdu: state.edu
    });
  };
  const cancelHandle = () => {
    authDispatch(AuthEventType.LoggingOut);
  };
  (0, _react.useEffect)(() => {
    if (authState.value === AuthStates.Idle) {
      setState({
        ...state,
        account: {
          value: "",
          message: ""
        },
        password: {
          value: "",
          message: ""
        },
        errorMessage: authState.context.error || ""
      });
    }
  }, [authState.context.error, authState.value]);
  (0, _react.useEffect)(() => {
    if (authState.value === AuthStates.LoginDone) {
      history.push("/");
    }
  }, [authState.value]);
  return /*#__PURE__*/_react.default.createElement(_Login.UiLogin, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, state.errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "errorMessage"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cancel"), state.errorMessage), !((_authState$context$re = authState.context.result) !== null && _authState$context$re !== void 0 && _authState$context$re.isNewMember) ? /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "subTitle"
  }, "Welcome!"), /*#__PURE__*/_react.default.createElement("h1", {
    className: "title"
  }, "\u5357\u4E00\u6578\u4F4D\u8CC7\u6E90\u5165\u5EAB\u5E73\u53F0"), /*#__PURE__*/_react.default.createElement("div", {
    className: "form"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "\u5E33\u865F",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F",
    message: state.account && state.account.message,
    value: state.account && state.account.value,
    onChange: e => onChange("account", e)
  }), /*#__PURE__*/_react.default.createElement(_Input.default.Password, {
    label: "\u5BC6\u78BC",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5BC6\u78BC",
    message: state.password && state.password.message,
    value: state.password && state.password.value,
    onChange: e => onChange("password", e)
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: submit,
    loading: authState.context.loading
  }, "\u767B\u5165"), /*#__PURE__*/_react.default.createElement("div", {
    className: "links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, "\u5FD8\u8A18\u5BC6\u78BC"), /*#__PURE__*/_react.default.createElement("div", null, "|"), /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, "\u524D\u5F80\u8A3B\u518A \u2192"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "iconBox"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "check_circle"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "largeTitle"
  }, "\u767B\u5165\u6210\u529F"), /*#__PURE__*/_react.default.createElement("div", null, "\u8ACB\u9078\u64C7\u6240\u5C6C\u5B78\u5236"), /*#__PURE__*/_react.default.createElement("div", {
    className: "prompt"
  }, "\u203B \u4E00\u65E6\u9078\u64C7\u5B8C\u6210\uFF0C\u82E5\u9700\u4FEE\u6539\u8ACB\u6D3D\u7CFB\u7D71\u7BA1\u7406\u54E1\uFF01"), /*#__PURE__*/_react.default.createElement(_Select.default, {
    options: authState.context.result.eduMap && authState.context.result.eduMap.map(item => ({
      name: item.name,
      value: item.code
    })) || _index.EDUCATIONAL,
    value: state.edu,
    onChange: value => setState({
      edu: value
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "btnBox"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: confirmHandle
  }, "\u78BA\u8A8D"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "orange",
    onClick: cancelHandle
  }, "\u53D6\u6D88")))));
};
var _default = exports.default = Login;
Login.propTypes = {
  platformName: _propTypes.default.string
};